import React from "react";
import { DragIcon } from "../../../utils";
export default (function (_ref) {
  var type = _ref.type;
  var typeToIcon = {};
  var icon = typeToIcon[type] || null;
  if (!icon && type === "drag") {
    icon = /*#__PURE__*/React.createElement(DragIcon, null);
  }
  return icon;
});